import React from "react";
import { FrameProvider, FrameRoot } from "../Organisms/Frame";
export var Layout = function Layout(param) {
  var children = param.children;
  return /*#__PURE__*/React.createElement(FrameProvider, null, /*#__PURE__*/React.createElement(FrameRoot, null, children));
};